import { crmClient, crmMedia } from '../../crm/client'
import { prefetchPicker } from './pickerQueries'

/** Warm the picker for an account (e.g. on hover of an attach button) through the console's CRM client. */
export function prefetchAccountPicker(accountId: string) {
  prefetchPicker(
    {
      gateway: (path, body) => crmClient.gateway(accountId, path, body),
      loadMedia: (url) => crmMedia.load(accountId, url),
    },
    accountId,
  )
}
